export const addProductToCart = (productCount) => async (dispatch) => {
  dispatch({
    type: "addTocart",
    payload: productCount,
  });
};

export const setProductsList = (data) => async (dispatch) => {
  dispatch({
    type: "setProductsList",
    payload: data,
  });
};

export const setProductsMeta = (meta) => async (dispatch) => {
  dispatch({
    type: "setProductsMeta",
    payload: meta,
  });
};

export const setProductSearched = (boolean) => async (dispatch) => {
  dispatch({
    type: "setProductSearched",
    payload: boolean,
  });
};

export const setUploadedGraphicImage = (src, filename) => async (dispatch) => {
  dispatch({
    type: "setUploadedGraphicImage",
    payload: { src, filename },
  });
};

export const setUploadedNotecardImage = (src, filename) => async (dispatch) => {
  dispatch({
    type: "setUploadedNotecardImage",
    payload: { src, filename },
  });
};

export const setPreviewImageSRC = (src, filename) => async (dispatch) => {
  dispatch({
    type: "setPreviewImageSRC",
    payload: { src, filename },
  });
};

export const setGraphicURL = (url) => async (dispatch) => {
  dispatch({
    type: "setGraphicURL",
    payload: url,
  });
};

export const setNotecardURL = (url) => async (dispatch) => {
  dispatch({
    type: "setNotecardURL",
    payload: url,
  });
};

export const setProductStats = (stats) => async (dispatch) => {
  dispatch({
    type: "setProductStats",
    payload: stats,
  });
};

export const setPersonalizedVariations = (variations) => async (dispatch) => {
  dispatch({
    type: "setPersonalizedVariations",
    payload: variations,
  });
};

export const setGraphicSwitches = (switches) => async (dispatch) => {
  dispatch({
    type: "setGraphicSwitches",
    payload: switches,
  });
};

export const clearPersonalizedVariations = () => async (dispatch) => {
  dispatch({ type: "clearPersonalizedVariations" });
};

export const setEtsySKUBeforeCreation = (data, merge = false) => async (dispatch) => {
  dispatch({
    type: "setEtsySKUBeforeCreation",
    payload: data,
    merge: merge,
  });
};

export const setAmazonSKUBeforeCreation = (data) => async (dispatch) => {
  dispatch({
    type: "setAmazonSKUBeforeCreation",
    payload: data,
  });
};

export const clearAmazonSKUBeforeCreation = () => async (dispatch) => {
  dispatch({
    type: "clearAmazonSKUBeforeCreation",
  });
};

export const setEtsyListings = (listings) => async (dispatch) => {
  dispatch({
    type: "setEtsyListings",
    payload: listings,
  });
};

export const setEtsyListing = (listing) => async (dispatch) => {
  dispatch({
    type: "setEtsyListing",
    payload: listing,
  });
};

export const setEtsyListingsLoading = (loading) => async (dispatch) => {
  dispatch({
    type: "setEtsyListingsLoading",
    payload: loading,
  });
};

export const setEtsyListingsBatchLoading = (loading) => async (dispatch) => {
  dispatch({
    type: "setEtsyListingsBatchLoading",
    payload: loading,
  });
};

export const appendEtsyListings = (listings) => async (dispatch) => {
  dispatch({
    type: "appendEtsyListings",
    payload: listings,
  });
};

export const clearEtsyListings = () => async (dispatch) => {
  dispatch({
    type: "clearEtsyListings",
  });
};

export const setLastEtsyOffset = (offset) => async (dispatch) => {
  dispatch({
    type: "setLastEtsyOffset",
    payload: offset,
  });
};

export const setEtsyResyncLoading = (loading) => async (dispatch) => {
  dispatch({
    type: "setEtsyResyncLoading",
    payload: loading,
  });
};

// Active listings actions
export const setEtsyListingsActive = (listings) => async (dispatch) => {
  dispatch({
    type: "setEtsyListingsActive",
    payload: listings,
  });
};

export const setEtsyListingsActiveLoading = (loading) => async (dispatch) => {
  dispatch({
    type: "setEtsyListingsActiveLoading",
    payload: loading,
  });
};

export const setEtsyResyncActiveLoading = (loading) => async (dispatch) => {
  dispatch({
    type: "setEtsyResyncActiveLoading",
    payload: loading,
  });
};

// Inactive listings actions
export const setEtsyListingsInactive = (listings) => async (dispatch) => {
  dispatch({
    type: "setEtsyListingsInactive",
    payload: listings,
  });
};

export const setEtsyListingsInactiveLoading = (loading) => async (dispatch) => {
  dispatch({
    type: "setEtsyListingsInactiveLoading",
    payload: loading,
  });
};

export const setEtsyResyncInactiveLoading = (loading) => async (dispatch) => {
  dispatch({
    type: "setEtsyResyncInactiveLoading",
    payload: loading,
  });
};

// Draft listings actions
export const setEtsyListingsDraft = (listings) => async (dispatch) => {
  dispatch({
    type: "setEtsyListingsDraft",
    payload: listings,
  });
};

export const setEtsyListingsDraftLoading = (loading) => async (dispatch) => {
  dispatch({
    type: "setEtsyListingsDraftLoading",
    payload: loading,
  });
};

export const setEtsyResyncDraftLoading = (loading) => async (dispatch) => {
  dispatch({
    type: "setEtsyResyncDraftLoading",
    payload: loading,
  });
};

// Current tab status action
export const setCurrentEtsyTabStatus = (status) => async (dispatch) => {
  dispatch({
    type: "setCurrentEtsyTabStatus",
    payload: status,
  });
};